import { useState, useEffect, useContext } from 'react';
import {
	FormControl,
	Stack,
	Button,
	Dialog,
	IconButton,
	Typography,
	InputLabel,
	Select,
	MenuItem,
	TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import getLogo from '../../../utils/getLogo';
import { getSupportedFantasyAPIData, updateUser } from '../../../api_helper/api';
import { UserProfileContext } from '../../../UserProfileContext';

const ConnectFantasyAccountModal = ({ isOpen, onClose, onSuccess }) => {
	const userProfileContext = useContext(UserProfileContext)[0];

	const [selectedFantasyPlatform, setSelectedFantasyPlatform] = useState();
	const [fantasyPlatforms, setFantasyPlatforms] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [fantraxUserSecret, setFantraxUserSecret] = useState('');

	const handleFantasyPlatformChange = (event) => {
		setSelectedFantasyPlatform(event.target.value);
	};

	const handleClickConnectFantasyAccount = async () => {
		setIsLoading(true);

		if (selectedFantasyPlatform.api === 'Yahoo! Fantasy Sports') {
			// Redirect user to authentication portal
			window.location.assign(selectedFantasyPlatform.authURL + `?endpoint=${window.location.pathname}`);
		} else if (selectedFantasyPlatform.api === 'Fantrax') {
			// Update user document with Fantrax data
			await updateUser({
				userId: userProfileContext._id,
				updatedFields: {
					fantraxCredentials: { userSecretId: fantraxUserSecret },
					connectedLeagueApis: Array.from(
						new Set([...userProfileContext.connectedLeagueApis, selectedFantasyPlatform.api]),
					),
				},
			});

			onClose();
			onSuccess({ fantasyPlatform: selectedFantasyPlatform.api });
		}

		setIsLoading(false);
	};

	const menuItem = (fantasyPlatform) => {
		return (
			<MenuItem key={fantasyPlatform} value={fantasyPlatform}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={getLogo({ api: fantasyPlatform.api })}
						style={{ width: '2rem', borderRadius: '0.2rem', marginRight: '0.5rem' }}
					/>
					{fantasyPlatform.api}
				</div>
			</MenuItem>
		);
	};

	useEffect(() => {
		const getFantasyPlatforms = async () => {
			const apiOptions = await getSupportedFantasyAPIData();
			setFantasyPlatforms(apiOptions);
		};
		getFantasyPlatforms();
	}, []);

	return (
		<Dialog open={isOpen} fullWidth>
			<IconButton className="close-button" aria-label="close" onClick={onClose}>
				<CloseIcon sx={{ fontSize: '1rem' }} />
			</IconButton>

			<Typography variant="h3" align="center" sx={{ my: 1 }}>
				Connect a Fantasy Account
			</Typography>

			<Typography variant="body1" align="center" sx={{ mb: 3 }}>
				Please select your a fantasy platform to connect to SportWise with.
			</Typography>

			<Stack alignItems="start" gap={1}>
				<FormControl fullWidth>
					<InputLabel id="fantasy-account-select-label">Select Fantasy Account</InputLabel>
					<Select
						labelId="fantasy-account-select-label"
						label="Select Fantasy Account"
						fullWidth
						value={selectedFantasyPlatform || ''}
						onChange={handleFantasyPlatformChange}
					>
						{fantasyPlatforms ? (
							fantasyPlatforms.length ? (
								fantasyPlatforms.map((fantasyPlatform) => menuItem(fantasyPlatform))
							) : (
								<MenuItem disabled={true}>No platforms found</MenuItem>
							)
						) : (
							<MenuItem disabled={true}>Loading...</MenuItem>
						)}
					</Select>

					{selectedFantasyPlatform?.api === 'Fantrax' && (
						<TextField
							label="Fantrax User Secret"
							value={fantraxUserSecret}
							onChange={(e) => setFantraxUserSecret(e.target.value)}
							sx={{ mt: 2 }}
						/>
					)}
				</FormControl>
			</Stack>

			<Button
				type="submit"
				color="primary"
				variant="contained"
				onClick={handleClickConnectFantasyAccount}
				disabled={isLoading}
				sx={{ mt: 2 }}
			>
				Connect Fantasy Account
			</Button>
		</Dialog>
	);
};

export default ConnectFantasyAccountModal;
